.research-content {
    padding: 0 12px 12px;
}
